// Historical investor data (earnings from bookings + capital injections)
// Format: { date: 'YYYY-MM-DD', amount: number, isCapital?: boolean }
// isCapital = true means this is a non-refundable capital investment (shown but not withdrawable)
export const historicalGains = [
  { date: '2024-02-24', amount: 15000, isCapital: true },
  { date: '2024-06-29', amount: 48.64 },
  { date: '2024-07-01', amount: 46.09 },
  { date: '2024-07-09', amount: 36.7 },
  { date: '2024-07-10', amount: 104.65 },
  { date: '2024-07-12', amount: 52.16 },
  { date: '2024-07-14', amount: 64.82 },
  { date: '2024-07-16', amount: 77.18 },
  { date: '2024-07-25', amount: 21.48 },
  { date: '2024-07-26', amount: 43.84 },
  { date: '2024-07-30', amount: 31.39 },
  { date: '2024-07-31', amount: 49.36 },
  { date: '2024-08-03', amount: 51.58 },
  { date: '2024-08-04', amount: 48.03 },
  { date: '2024-08-10', amount: 11.84 },
  { date: '2024-08-13', amount: 26.16 },
  { date: '2024-08-20', amount: 116.81 },
  { date: '2024-08-22', amount: 30.08 },
  { date: '2024-08-24', amount: 67.39 },
  { date: '2024-08-25', amount: 36.4 },
  { date: '2024-08-26', amount: 15000, isCapital: true },
  { date: '2024-08-27', amount: 85.66 },
  { date: '2024-09-04', amount: 85.12 },
  { date: '2024-09-05', amount: 128.3 },
  { date: '2024-09-06', amount: 60.23 },
  { date: '2024-09-07', amount: 109.62 },
  { date: '2024-09-19', amount: 44.6 },
  { date: '2024-09-20', amount: 28.31 },
  { date: '2024-09-21', amount: 18.08 },
  { date: '2024-09-24', amount: 7.04 },
  { date: '2024-09-25', amount: 85.86 },
  { date: '2024-09-27', amount: 234.32 },
  { date: '2024-10-05', amount: 30.56 },
  { date: '2024-10-06', amount: 52.86 },
  { date: '2024-10-10', amount: 44.98 },
  { date: '2024-10-12', amount: 43.28 },
  { date: '2024-10-18', amount: 92.58 },
  { date: '2024-10-22', amount: 7.84 },
  { date: '2024-10-24', amount: 86.54 },
  { date: '2024-10-26', amount: 64.65 },
  { date: '2024-11-05', amount: 72.61 },
  { date: '2024-11-15', amount: 28.03 },
  { date: '2024-12-04', amount: 15.76 },
  { date: '2024-12-05', amount: 44.7 },
  { date: '2024-12-06', amount: 76.67 },
  { date: '2024-12-17', amount: 38.82 },
  { date: '2024-12-20', amount: 28.71 },
  { date: '2025-01-01', amount: 7.94 },
  { date: '2025-01-10', amount: 52.35 },
  { date: '2025-02-07', amount: 6.72 },
  { date: '2025-02-16', amount: 4.96 }
];

// Calculate total historical gains (earnings only, excludes capital)
export const totalHistoricalGains = historicalGains
  .filter(entry => !entry.isCapital)
  .reduce((sum, entry) => sum + entry.amount, 0);

// Calculate total capital invested (non-refundable)
export const totalCapitalInvested = historicalGains
  .filter(entry => entry.isCapital)
  .reduce((sum, entry) => sum + entry.amount, 0);
